import { apiCall } from "../../service/api-service.js";

// Dashboard Counts
export const getCountsApi = async (params) => 
  apiCall("get", "dashboard/count");

// Asset Activity
export const getActivityApi = async (params = {}) => {
  if (!params.period && params.month && params.year) {
    const paddedMonth = String(params.month).padStart(2, "0");
    params.period = `${params.year}-${paddedMonth}`;
    delete params.month;
    delete params.year;
  }
  const response = await apiCall("post", "dashboard/asset_activity", params);
  return response;
};

// Consumption
export const getConsumptionApi = async (params = {}) => {
  if (!params.from_date && params.month && params.year) {
    const paddedMonth = String(params.month).padStart(2, "0");
    params.from_date = `${params.year}-${paddedMonth}-01`;
    const lastDay = new Date(params.year, params.month, 0).getDate();
    params.to_date = `${params.year}-${paddedMonth}-${lastDay}`;
    delete params.month;
    delete params.year;
  }
  const response = await apiCall("post", "dashboard/location_consumption", params);
  return response;
};

// Top & Least Usage
export const getTlusageApi = async (params = {}) => {
  if (!params.period && params.month && params.year) {
    const paddedMonth = String(params.month).padStart(2, "0");
    params.period = `${params.year}-${paddedMonth}`;
    delete params.month;
    delete params.year;
  }
  const response = await apiCall("post", "dashboard/topleast_usage", params);
  return response;
};

export const getGatelogApi = async (params = {}) => {
  if (!params.period && params.month && params.year) {
    const paddedMonth = String(params.month).padStart(2, "0");
    params.period = `${params.year}-${paddedMonth}`;
    delete params.month;
    delete params.year;
  }
  const response = await apiCall("post", "dashboard/gatelog_activity", params);
  return response;
};
export const getyearTotalApi = async (params = {}) => 
  apiCall("post", "dashboard/year_month_cost", params);
export const getMonthTotalApi = async (params = {}) => 
  apiCall("post", "dashboard/month_cost", params);
export const getDeprecitTotalApi = async (params = {}) => 
  apiCall("post", "dashboard/monthly_deprication", params);
export const getEmployeeApi = async (params = {}) => 
  apiCall("post", "dashboard/employee_asset", params);
export const getCurrentValueApi = async () => 
  apiCall("get", "dashboard/current_value");

export const getDailyprograssApi = async (params = {}) => 
  apiCall("post", "dashboard/daily_progress", params);
